<div class="account-pages my-5 pt-sm-5">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card">
                   
                    <div class="card-body p-4"> 
                        <div class="text-center mt-2">
                            <h5 class="text-primary">Welcome Back !</h5>
                            <p class="text-muted">Sign in to continue to Book Review Portal.</p>
                        </div>
                        <div class="p-2 mt-4">
                            <form [formGroup]="loginForm" (submit)="onLogin()" novalidate>
                                <div class="mb-3">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-icon matPrefix>admin_panel_settings</mat-icon>
                                        <mat-label>User Name/Email</mat-label>
                                        <input matInput formControlName="username" value="" autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="mb-3">
                                    <mat-form-field class="example-full-width" appearance="outline">
                                        <mat-label>Password</mat-label>
                                        <mat-icon matPrefix>password</mat-icon>
                                        <input matInput formControlName="password" type="password" value=""
                                            autocomplete="off">
                                    </mat-form-field>
                                </div>
                                <div class="form-check">
                                    <!-- <input type="checkbox" class="form-check-input" id="auth-remember-check">
                                    <label class="form-check-label" for="auth-remember-check">Remember me</label> -->
                                </div>
                                <div class="mt-3 text-end">
                                    <button class="pbmit-btn" type="submit">Log In</button>
                                </div>
                            </form>
                        </div>
    
                    </div>
                </div>
  
                <div class="mt-5 text-center">
                    <p>Copyright © <script>document.write(new Date().getFullYear())</script> AILENS. All Rights Reserved.</p>
                </div>
  
            </div>
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
  </div>